
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes, } from '@angular/router';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { CustomerProfileComponent } from './profile/profile.component';
import { CustomerAlertsComponent } from './alerts/alerts.component';


const routes: Routes = [
    { path: 'profile', component: CustomerProfileComponent },
    { path: 'alerts', component: CustomerAlertsComponent }
];


@NgModule({
    declarations: [
    ],
    imports: [
        CommonModule,
        AgGridModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        NgbModule,
        NgbDatepickerModule
    ],
})
export class CustomerModule { }
